<template>
  <div class="ecg-page" v-loading="theHeartloading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <!-- 顶部导航栏 -->
    <header class="ecg-header" :style="{paddingTop: statusBarHeight + 'px'}">
      <div class="header-background">
        <img src="@/assets/healthReportList/headbackground.png" alt="背景" class="header-bg-img" />
      </div>
      <div class="header-nav">
        <div class="nav-back-wrapper">
          <button class="nav-back-btn" @click="goBack">
            <i class="el-icon-arrow-left"></i>
          </button>
        </div>
        <div class="nav-title">心电</div>
        <div class="nav-placeholder"></div>
      </div>
    </header>

    <!-- 分段控制器 -->
    <div class="segmented-control">
      <div 
        class="segment-item" 
        :class="{ active: activeTab === 'watch' }" 
        @click="switchTab('watch')"
      >
        手表心电
      </div>
      <div 
        class="segment-item" 
        :class="{ active: activeTab === 'device' }" 
        @click="switchTab('device')"
      >
        心电仪
      </div>
    </div>
    
    <!-- 手表心电列表 -->
    <div v-if="activeTab === 'watch'" class="ecg-list-container">
      <div 
        class="ecg-card" 
        v-if="list.length > 0" 
        v-for="(item, index) in list" 
        :key="index" 
        @click="details(item)"
      >
        <div class="ecg-card-time">{{ item.dataTime }}</div>
        <div class="ecg-card-data">
          <!-- 心率 -->
          <div class="data-item heart-rate">
            <div class="data-value">{{ item.heartRat }}<span class="data-unit">次/分</span></div>
            <div class="data-label">心率</div>
          </div>
          <!-- QT间期 -->
          <div class="data-item qt-interval">
            <div class="data-value">{{ item.qt }}<span class="data-unit">毫秒</span></div>
            <div class="data-label">QT间期</div>
          </div>
          <!-- HRV -->
          <div class="data-item hrv">
            <div class="data-value">{{ item.hrv }}<span class="data-unit">毫秒</span></div>
            <div class="data-label">HRV</div>
          </div>
        </div>
      </div>
      <div v-if="list.length === 0" class="empty-state">
        <i class="el-icon-document"></i>
        <p>暂无手表心电数据</p>
      </div>
    </div>

    <!-- 心电仪器列表 -->
    <div v-if="activeTab === 'device'" class="ecg-list-container">
      <div class="device-ecg-card" v-if="deviceList.length > 0" v-for="(item, index) in deviceList" :key="'device-' + index">
        <!-- 顶部标题栏 -->
        <div class="device-card-header">
          <div class="device-number">
            <div class="number-badge">{{ index + 1 }}</div>
            <span class="record-title">测量记录</span>
          </div>
        </div>

        <!-- 主要内容区域 -->
        <div class="device-card-content">
          <!-- 左侧心电仪器图片 -->
          <div class="device-image-wrapper">
            <img :src="ecgDeviceImage" alt="心电记录仪" class="device-image" />
          </div>
          
          <!-- 右侧文本信息 -->
          <div class="device-info-wrapper">
            <div class="info-item">
              <span class="info-label">测量时间：</span>
              <span class="info-value">{{ item.recordStartTime }}</span>
            </div>
            <div class="info-item" v-if="item.completed">
              <span class="info-label">测量时长：</span>
              <span class="info-value">{{ item.durationStr }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">数据上传：</span>
              <span class="info-value" :class="{ 'status-uploaded': item.completed, 'status-not-uploaded': !item.completed }">
                {{ item.completed ? '已上传' : '未上传' }}
              </span>
            </div>
          </div>
        </div>

        <!-- 异常提醒 -->
        <div class="device-warning" v-if="item.discard">
          <img src="@/assets/theHeartList/red.png" alt="警告" class="warning-icon" />
          <span class="warning-text">异常提醒：数据质量差，建议重测</span>
        </div>

        <!-- 报告按钮区域 -->
        <div class="device-card-footer" v-else-if="item.pdfFilePath">
          <div class="pdf-btn" @click.stop="openPdf(item)">
            <i class="el-icon-view"></i>
            <span>查看PDF报告</span>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="copy-btn" @click.stop="copyPdfLink(item)">
            <i class="el-icon-document-copy"></i>
            <span>复制链接</span>
          </div>
        </div>
        <div class="device-card-footer" v-else-if="!item.discard && !item.pdfFilePath">
          <div class="no-pdf-text">
            <i class="el-icon-warning-outline"></i>
            <span>报告生成中，请稍后查看</span>
          </div>
        </div>
      </div>
      <div v-if="deviceList.length === 0" class="empty-state">
        <i class="el-icon-document"></i>
        <p>暂无心电仪数据</p>
      </div>
    </div>
    <!-- <div class="add1" @click="startLoading()" >
        开启ECG
    </div> -->
    <!-- <div class="add"  v-else>
        开启ECG
    </div> -->
   
    <!-- 时间选择器已移除 -->
  </div>
</template>
<script>
import * as echarts from "echarts";
import { findEcgListPage, getSwkMeasurementsByUser } from '@/api/activity'
import { mapState } from 'pinia';
import { useUserStore } from '@/stores/user';
import { useGlobalStore } from '@/stores/global';

export default {
  data() {
    return {
      // countdown:60,
      theHeartloading: false,
      progress: 100,
      echartsTime: "00:00",
      name: "400",
      time: "1",
      time1: "2",
      // 时间筛选已移除
      week: "",
      chartInstance: null,
      list:[],
      deviceList: [], // 心电仪器列表
      timerId: true,
      activeTab: 'watch', // 当前激活的tab：watch-手表心电，device-心电仪器
      // 分页
      pn: 1,
      ps: 10,
      loading: false,
      noMore: false,
      // 设备分页
      devicePageIndex: 1,
      devicePageSize: 10,
      deviceLoading: false,
      deviceNoMore: false,
    };
  },
  components: { },
  computed: {
    ...mapState(useUserStore, ['userInfo']),
    ...mapState(useGlobalStore, ['statusBarHeight']),
    loadingText() {
      return this.theHeartloading ? `` : '';
    },
    /**
     * 心电记录仪图片路径
     */
    ecgDeviceImage() {
      return require('@/views/binding/img/xd.jpg');
    }
  },
 
  mounted() {
    if(localStorage.getItem('oldAge') == 1) {
          document.getElementById("html").style.fontSize = "44px";
        }
    document.title = '心电' 
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#F3F4F6 !important");
      // window.enableLoading = this.enableLoading
     
    // 初始化加载手表心电分页列表（不限日期）
    this.resetAndLoad();
    // 预加载心电仪器（不限日期）
    if (this.userInfo.userCode) {
      this.resetDeviceAndLoad();
    }
    // 监听滚动加载更多
    window.addEventListener('scroll', this.onScroll, { passive: true });
  },

  beforeDestroy() {
    // 在组件销毁前移除resize事件监听
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#F3F4F6 !important");
    // }
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    // countdown() {
    //   var count = 3;
    //   var than = this
    //   var timer = setInterval(function() {
    //     count--;
    //     if (count === 0) {
    //       clearInterval(timer);
    //       than.timerId = false
    //       console.log('倒计时结束',than.timerId);
    //     }
    //   }, 1000);
    // },
    /**
     * 获取手表心电数据
     */
    async loadEcgPage() {
      if (this.loading || this.noMore) return;
      this.loading = true;
      try {
        const res = await findEcgListPage({ pn: this.pn, ps: this.ps });
        let items = [];
        let total = 0;
        if (res && (res.code == 1000 || res.code === 'OK')) {
          if (Array.isArray(res.data)) {
            items = res.data;
          } else if (res.data && Array.isArray(res.data.list)) {
            items = res.data.list;
          }
          total = res.total || (res.data && res.data.total) || 0;
        }
        if (items.length > 0) {
          this.list = this.list.concat(items);
          this.pn += 1;
          // 判断是否已无更多
          if (total && this.list.length >= total) this.noMore = true;
          if (!total && items.length < this.ps) this.noMore = true;
        } else {
          this.noMore = true;
        }
      } catch (e) {
        this.noMore = true;
      } finally {
        this.loading = false;
      }
    },
    resetAndLoad() {
      this.pn = 1;
      this.noMore = false;
      this.list = [];
      this.loadEcgPage();
    },
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const fullHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      if (fullHeight - (scrollTop + windowHeight) < 100) {
        if (this.activeTab === 'watch') {
          this.loadEcgPage();
        } else if (this.activeTab === 'device') {
          this.loadDevicePage();
        }
      }
    },

    /**
     * 获取心电仪器数据（分页）
     */
    async loadDevicePage() {
      if (!this.userInfo.userCode) return;
      if (this.deviceLoading || this.deviceNoMore) return;
      this.deviceLoading = true;
      try {
        const res = await getSwkMeasurementsByUser({
          userCode: this.userInfo.userCode,
          pageIndex: this.devicePageIndex,
          pageSize: this.devicePageSize
        });
        let items = [];
        let total = 0;
        if (res && (res.code == 1000 || res.code === 'OK')) {
          if (Array.isArray(res.data)) {
            items = res.data;
          } else if (res.data && Array.isArray(res.data.list)) {
            items = res.data.list;
          }
          total = res.total || (res.data && res.data.total) || 0;
        }
        if (items.length > 0) {
          this.deviceList = this.deviceList.concat(items);
          this.devicePageIndex += 1;
          if (total && this.deviceList.length >= total) this.deviceNoMore = true;
          if (!total && items.length < this.devicePageSize) this.deviceNoMore = true;
        } else {
          this.deviceNoMore = true;
        }
      } catch (e) {
        this.deviceNoMore = true;
      } finally {
        this.deviceLoading = false;
      }
    },
    resetDeviceAndLoad() {
      this.devicePageIndex = 1;
      this.deviceNoMore = false;
      this.deviceList = [];
      this.loadDevicePage();
    },

    /**
     * 切换Tab
     */
    switchTab(tab) {
      this.activeTab = tab;
      
      // 根据切换的tab调用对应接口（无时间筛选）
      if (tab === 'watch') {
        if (this.list.length === 0) this.resetAndLoad();
      } else if (tab === 'device') {
        if (this.deviceList.length === 0) this.resetDeviceAndLoad();
      }
    },

    /**
     * 打开PDF报告
     * 使用H5 PDF查看器，在APP和浏览器中都能正常查看
     */
    openPdf(item) {
      if (!item.pdfFilePath) {
        this.$message.warning('暂无PDF报告，请稍后查看');
        return;
      }
      
      const pdfUrl = item.pdfFilePath;
      
      // 统一跳转到PDF查看器页面，使用Mozilla PDF.js在线服务
      // 这样在APP的WebView和浏览器中都能正常查看PDF
      this.$router.push({
        path: '/pdfViewer',
        query: {
          pdfUrl: encodeURIComponent(pdfUrl)
        }
      });
    },

    /**
     * 复制PDF报告链接
     * @param {Object} item - 测量记录项
     */
    copyPdfLink(item) {
      if (!item.pdfFilePath) {
        this.$message.warning('暂无PDF报告链接');
        return;
      }

      const pdfUrl = item.pdfFilePath;
      
      // 创建临时输入框
      const input = document.createElement('input');
      input.value = pdfUrl;
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      
      // 选择并复制
      input.select();
      input.setSelectionRange(0, 99999); // 兼容移动端
      
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.$message.success('PDF链接已复制到剪贴板');
        } else {
          this.$message.error('复制失败');
        }
      } catch (err) {
        console.error('复制失败:', err);
        this.$message.error('复制失败');
      }
      
      // 移除临时输入框
      document.body.removeChild(input);
    },
    //0-开始 1-结束 3-同功能开启中，先停止再开启 255-采集中 6-导联脱落（佩戴错误）
    // enableLoading(str) {
    //   if(str == 0) {
    //     this.theHeartloading = true
    //     console.log(this.theHeartloading)
    //   }else if(str == 1) {
    //     this.theHeartloading = false
    //     const today = new Date();
    //     const year = today.getFullYear();
    //     const month = today.getMonth() + 1; // 月份从0开始计算，需要加1
    //     const day = today.getDate();
    //     this.newtime = year + '年' + month + '月' + day + '日'
    //     this.getData(year + '-' + month + '-' + day)
    //   }else if(str == 255) {
    //     this.theHeartloading = true
    //   }else if(str == 6) {
    //     this.$message({
    //         message: '导联脱落（佩戴错误）',
    //         type: 'warning'
    //       });
    //       this.theHeartloading = false
    //   }else if(str == 3) {
    //     this.$message({
    //         message: '同功能开启中，先停止再开启',
    //         type: 'warning'
    //       });
    //       this.theHeartloading = false
    //   }
    // },
    // startLoading() {
    //   if (this.$env.inDjxApp){
    //         if (this.$env.inAndroid){
    //           if(JSInterface.ecgStart() == '9999') {
    //               this.$message({
    //                 message: '未检测到附近设备',
    //                 type: 'warning'
    //               });
    //             }
    //         }else if (this.$env.inIos) {
    //           if(window.webkit.messageHandlers.ecgStart.postMessage(null) == '9999') {
    //               this.$message({
    //                 message: '未检测到附近设备',
    //                 type: 'warning'
    //               });
    //             }
    //         }
    //       }
    
    // },
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.go(-1);
    },
    /**
     * 查看详情
     */
    details(item) {
      localStorage.setItem('dataTime', item.dataTime.slice(0, 10))
      this.$router.push({
        path: "/theHeart",
        query: {
          ecg: 1,
          id: item.id,
        }
      });
    },
  
    // 时间相关工具已移除
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "微软雅黑", "PingFang SC", "Microsoft YaHei", sans-serif;
}

.ecg-page {
  min-height: 100vh;
  background-color: #F7F7F7;
  padding-bottom: 20px;
}

/* 顶部导航栏 */
.ecg-header {
  position: relative;
  width: 100%;
  overflow: hidden;
  margin-bottom: 0;
}

.header-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.header-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.header-nav {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  min-height: 44px;
}

.nav-back-wrapper {
  flex-shrink: 0;
}

.nav-back-btn {
  width: 28px;
  height: 28px;
  padding: 0;
  background: #ffffff;
  border: none;
  border-radius: 50%;
  color: #000000;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.nav-back-btn i {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
}

.nav-back-btn:hover {
  background: #f5f5f5;
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.nav-back-btn:active {
  transform: translateY(0) scale(0.95);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.nav-title {
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #000000;
}

.nav-placeholder {
  width: 28px;
}

/* 分段控制器 */
.segmented-control {
  display: flex;
  background-color: #F0F0F0;
  border-radius: 8px;
  padding: 4px;
  margin: 16px;
  gap: 4px;
}

.segment-item {
  flex: 1;
  text-align: center;
  padding: 10px 0;
  font-size: 15px;
  color: #666666;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 8px;
  font-weight: 400;
  position: relative;
  overflow: hidden;
}

.segment-item.active {
  background-image: url('~@/assets/healthReportList/tab.png');
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  color: #ffffff;
  font-weight: 500;
}

.segment-item:active {
  opacity: 0.8;
}

/* 空状态样式 */
.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: #999999;
}

.empty-state i {
  font-size: 64px;
  color: #CCCCCC;
  margin-bottom: 16px;
  display: block;
}

.empty-state p {
  font-size: 14px;
  color: #999999;
  margin-top: 8px;
}

/* 心电仪器列表样式 */
.device-ecg-card {
  width: 100%;
  margin: 0 auto 12px;
  background: #ffffff;
  border-radius: 12px;
  padding: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
}

.device-ecg-card:active {
  transform: scale(0.98);
  opacity: 0.9;
}

/* 顶部标题栏 */
.device-card-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #ffffff;
}

.device-number {
  display: flex;
  align-items: center;
  gap: 10px;
}

.number-badge {
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  flex-shrink: 0;
}

.record-title {
  font-size: 15px;
  font-weight: 500;
  color: #333333;
}

/* 主要内容区域 */
.device-card-content {
  display: flex;
  align-items: flex-start;
  padding: 0 16px 12px;
  gap: 12px;
}

.device-image-wrapper {
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F8F9FA;
  border-radius: 8px;
  overflow: hidden;
}

.device-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.device-info-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 4px;
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 1.5;
}

.info-label {
  color: #666666;
  margin-right: 4px;
  flex-shrink: 0;
}

.info-value {
  color: #333333;
  font-weight: 400;
}

.info-value.status-uploaded {
  color: #00C275;
  font-weight: 500;
}

.info-value.status-not-uploaded {
  color: #FF8C00;
  font-weight: 500;
}

/* 异常警告 */
.device-warning {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  background: #FFF5F5;
  border-top: 1px solid #FFE5E5;
}

.warning-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.warning-text {
  font-size: 13px;
  color: #FF4444;
  line-height: 1.5;
}

/* 报告按钮区域 */
.device-card-footer {
  padding: 12px 16px 16px;
  background: #FFFFFF;
  display: flex;
  gap: 10px;
  border-top: 1px solid #F0F0F0;
}

.pdf-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  color: #ffffff;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 194, 117, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
}

.pdf-btn i:first-child {
  font-size: 16px;
}

.pdf-btn i:last-child {
  font-size: 12px;
  margin-left: 2px;
}

.pdf-btn:active {
  background: linear-gradient(135deg, #00B068 0%, #45C4B8 100%);
  box-shadow: 0 2px 8px rgba(0, 194, 117, 0.2);
  transform: scale(0.98);
}

/* 复制按钮样式 */
.copy-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px 16px;
  background: #F8F9FA;
  color: #333333;
  border: 1px solid #E9ECEF;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
  min-width: 100px;
}

.copy-btn i {
  font-size: 16px;
  color: #666666;
}

.copy-btn:active {
  background: #E9ECEF;
  transform: scale(0.98);
}

.device-card-footer .no-pdf-text {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 16px;
  background: #FFF2E8;
  color: #FF8C00;
  border-radius: 8px;
  font-size: 13px;
  border: 1px dashed #FFCC99;
}

.device-card-footer .no-pdf-text i {
  font-size: 16px;
}
/* 列表容器 */
.ecg-list-container {
  padding: 16px;
}

/* 心电卡片 */
.ecg-card {
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: all 0.3s ease;
}

.ecg-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.ecg-card:active {
  transform: translateY(0);
}

.ecg-card-time {
  font-size: 13px;
  color: #999999;
  margin-bottom: 12px;
  line-height: 18px;
}

.ecg-card-data {
  display: flex;
  gap: 12px;
  justify-content: space-between;
}

.data-item {
  flex: 1;
  border-radius: 10px;
  padding: 12px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80px;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
}

/* 心率 - 粉色背景 */
.data-item.heart-rate {
  background-image: url('~@/assets/theHeartList/Heartratebackground.png');
  background-color: #FFE5E5;
}

/* QT间期 - 橙色背景 */
.data-item.qt-interval {
  background-image: url('~@/assets/theHeartList/Qtbackground.png');
  background-color: #FFE5CC;
}

/* HRV - 绿色背景 */
.data-item.hrv {
  background-image: url('~@/assets/theHeartList/HRVbackground.png');
  background-color: #E5F5E5;
}

.data-value {
  font-size: 22px;
  font-weight: 600;
  color: #333333;
  line-height: 1.2;
  text-align: center;
  margin-bottom: 6px;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.data-unit {
  font-size: 13px;
  font-weight: 400;
  color: #666666;
  margin-left: 2px;
}

.data-label {
  font-size: 13px;
  color: #999999;
  text-align: center;
  line-height: 18px;
  margin-top: 2px;
}
.add1 {
  width: 90%;
  margin: 0 auto;
  text-align: center;
  font-size: 20px;
  border: 1px solid #00c275;
  padding: 10px 0px;
  border-radius: 48px;
  color: #fff;
  background-color: #00c275;
  margin-top:20px ;
}
.add {
  width: 90%;
  margin: 0 auto;
  text-align: center;
  font-size: 20px;
  border: 1px solid #ffffff;
  padding: 10px 0px;
  border-radius: 48px;
  color: #fff;
  background-color: #cccccc;
  margin-top:20px ;
}

::v-deep .el-loading-spinner i {
  color: #00c275;
}

::v-deep .el-loading-spinner .el-loading-text {
  color: #00c275;
}

</style>


// WEBPACK FOOTER //
// src/views/theHeart/theHeartList.vue